import Heading from '@eduzz/houston-ui/Typography/Heading';
import { Grid, Paper } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import User from 'classes/User';
import React from 'react';
import { connect } from 'react-redux';
import { EProductType } from 'v2/interfaces/product';

import { SolidaritySquadModal } from '../../SolidaritySquad/Modal';
import CheckoutBumpHelperText from './CheckoutBumpHelperText';
import Delivery from './Delivery';
import ProductDetails from './ProductDetails';
import ShareableLinks from './ShareableLinks';
import styles from './styles';

import type IProduct from 'interfaces/IProduct';
import type IUser from 'interfaces/IUser';

interface IProps extends StyledComponentProps {
  product: IProduct;
  currentUser: IUser;
}

interface IStates {
  isSolidaritySquadModalOpen: boolean;
}

class Preview extends React.Component<IProps, IStates> {
  constructor(props: any) {
    super(props);
    this.state = {
      isSolidaritySquadModalOpen: true,
    };
  }

  handleCloseSolidaritySquadModal = () => {
    this.setState({
      isSolidaritySquadModalOpen: false,
    });
  };

  render() {
    const { product, classes, currentUser } = this.props;
    const { isSolidaritySquadModalOpen } = this.state;

    const productPhysicalAndUserElite = product.type === 3 && currentUser?.is_elite;

    return (
      <>
        <SolidaritySquadModal isOpen={isSolidaritySquadModalOpen} handleClose={this.handleCloseSolidaritySquadModal} productId={product.id} />
        <Paper className={classes.paper}>
          <div className='title'>
            <Heading as='h3' size='md' color='primary'>
              Tudo certo!
            </Heading>
            <Heading as='h3' size='md' color='primary'>
              Seu produto foi enviado para moderação
            </Heading>
          </div>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <p className='text'>
                A análise de conteúdos pode levar até 3 dias úteis, mas não se preocupe, já liberamos seu link de divulgação e te avisaremos quando o
                produto estiver aprovado para você começar suas vendas!
              </p>
            </Grid>
            <ProductDetails product={product} />
            <Grid item xs={12} md={9}>
              {(product.type !== EProductType.PHYSICAL || productPhysicalAndUserElite) && (
                <ShareableLinks productId={product.id} isWhiteBelt={!currentUser?.is_elite} />
              )}
            </Grid>
            <Grid item xs={12} className='deliver-section'>
              <Delivery product={product} />
            </Grid>
            <Grid>
              <CheckoutBumpHelperText />
            </Grid>
          </Grid>
        </Paper>
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    product: state.components.newProductWizard.product,
    currentUser: new User(state.orbita.User.user),
  };
}

export default styles(connect(mapStateToProps)(Preview));
